import React from 'react';
import './App.css';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Papa from 'papaparse';
import Moment from 'moment';
import ImageGallery from 'react-image-gallery';
import Genealogie from './genealogie.jpg';

Highcharts.setOptions({
  lang: {
          loading: 'Chargement...',
          months: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
          weekdays: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
          shortMonths: ['jan', 'fév', 'mar', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'],
          exportButtonTitle: "Exporter",
          printButtonTitle: "Imprimer",
          rangeSelectorFrom: "Du",
          rangeSelectorTo: "au",
          rangeSelectorZoom: "Période",
          downloadPNG: 'Télécharger en PNG',
          downloadJPEG: 'Télécharger en JPEG',
          downloadPDF: 'Télécharger en PDF',
          downloadSVG: 'Télécharger en SVG',
          resetZoom: "Réinitialiser le zoom",
          resetZoomTitle: "Réinitialiser le zoom",
          thousandsSep: "",
          decimalPoint: ',' 
      }        
});

class App extends React.Component {
  state = {
    Array_donnees : [],
    option_chart : {}
  }

  componentDidMount() {
   this.getCsvData();
  }

  fetchCsv() {
    return fetch('/data/donnees.csv').then(function (response) {
        let reader = response.body.getReader();
        let decoder = new TextDecoder('utf-8');

        return reader.read().then(function (result) {
            return decoder.decode(result.value);
        });
    });
  }

async getCsvData() {
  let csvData = await this.fetchCsv();
    let toto = Papa.parse(csvData, {
        complete: this.getData
    });
    var dataset_donnees = [];
    var couleur = [0,'#007FFF','grey','yellow','red','limegreen','#FF7F00','grey','blue','#CC9933','deeppink','blue'];
    var nom_ruche = [0,'ruche historique','ruche du milieu','ruche jaune','essaim de 2019','ruche verte','ruche ocre','ruche du milieu post transfert','ruche au carré bleu','ruche au carré ocre','ruche à poignées','essaim 2022'];
    for (var i = 1; i < toto.data[0].length; i++) {
      var poids_ruche_i = [];
      for (var j = 1; j < toto.data.length; j++) {
        if (toto.data[j][i] !== "#N/A") {
          var madate = (Moment(toto.data[j][0],"DD-MM-YYYY").add(22, 'hours')).valueOf();
          var donnee = parseFloat(toto.data[j][i]);
          poids_ruche_i.push({x: madate, y: donnee});
        };
      };      
      dataset_donnees.push({
        animation: false,
        name: nom_ruche[i],
        color: couleur[i],
        data: poids_ruche_i,
      });
    };
 
    this.setState({
      option_chart: {
        chart: {
          animation: false,
          plotBackgroundColor: '#E0E0E0',
          zoomType: 'x'
        },
        title: {
          text: 'Evolution des masses des ruches au cours du temps'
        },
        series: dataset_donnees,
        credits: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
//            second: '%Y-%m-%d<br/>%H:%M:%S',
//            minute: '%Y-%m-%d<br/>%H:%M',
//            hour: '%Y-%m-%d<br/>%H:%M',
            day: '%e %b',
//            week: '%d-%m<br/>%Y',
            week: '%e %b',
            month: '%m-%Y',
            year: '%Y'
          },
        },
        yAxis: [{
            title: {
                text: 'Masse des ruches (en kg)'
            }
        },{
            linkedTo: 0,
            opposite: true,
            title: {text:null}
        }],
      }
    });
   
}


  render() {
// console.log(this.state.option_chart);
const images = [
  {
    original: '/data/les_debuts_optimise.jpg',
    originalAlt: "erreur affichage photo",
    originalTitle: "Les débuts en 2013 !!!",
    thumbnail: '/data/les_debuts_optimise.jpg',
    thumbnailTitle: "Les débuts en 2013 !!!"
  },
  {
    original: '/data/rucher_LaLlagonne_loin_optimise.jpg',
    originalAlt: "erreur affichage photo",
    originalTitle: "Rucher à La Llagonne",
    thumbnail: '/data/rucher_LaLlagonne_loin_optimise.jpg',
    thumbnailTitle: "Rucher à La Llagonne"
  },
  {
    original: '/data/rucher_LaLlagonne_proche_optimise.jpg',
    originalAlt: "erreur affichage photo",
    originalTitle: "Zoom sur le rucher à La Llagonne",
    thumbnail: '/data/rucher_LaLlagonne_proche_optimise.jpg',
    thumbnailTitle: "Zoom sur le rucher à La Llagonne"
},
  {
    original: '/data/essaim_020520_optimise.jpg',
    originalAlt: "erreur affichage photo",
    originalTitle: "Essaim formé en mai 2020",
    thumbnail: '/data/essaim_020520_optimise.jpg',
    thumbnailTitle: "Essaim formé en mai 2020"
}
]

    return (
      <div className="zozo">
        <h1 align='center'>Suivi des ruches</h1>
        <br/>
        <div style={{fontSize:12}}>
        <a href="#evenementiel">Quelques événements d'intérêt</a>, <a href="#photos"> quelques photos</a> …
        <br/><a href="#genealogie">  … et la généalogie des essaims</a>      
        </div>
        <br/>
        <br/>
        <div className="Graphique" style={{margin:"0 2%"}}>
        <HighchartsReact highcharts={Highcharts} allowChartUpdate={true} options={this.state.option_chart}/>
        </div>
        <br/>
        <div style={{fontSize:13}}>
        <i>Il est possible de cliquer sur les noms des ruches dans la légende pour faire disparaître ou ré-apparaître les données relatives à une ou plusieurs ruches
          <br/>
          Il est aussi possible de zoomer sur une plage de dates en sélectionnant la région correspondante sur l'axe des x.
          <br/>
          ATTENTION: Les masses de deux ruches ne doivent pas être comparées l'une avec l'autre. En effet, le bâti de la ruche (base, corps, toit, nourrisseur…) est parfois inclus parfois exclu de la mesure de masse. Et les masses correspondantes sont en plus variables d'une ruche à l'autre.
          En particulier, pour les essaims de l'année 2020, y compris celui qui est hebergé par la ruche du milieu, la masse correspond essentiellement à celle des abeilles et de leurs produits (cire, miel, pollen, couvain…).
        </i>
        </div>
        <balise id="evenementiel"> 
          <h4 align='left'>Evénements</h4>
          <div style={{fontSize:13}}>
            18 septembre 2022: récolte d'environ 21 kg de miel des ruches ocre et jaune
            <br/>
            20 août 2022: retour des 2 ruches à Pignan
            <br/>
            13 août 2022: récolte de 4,5 kg de miel à partir de l'essaim 2022 et de la ruche jaune
            <br/>
            19 juillet 2022: retour de la ruche ocre à Pignan
            <br/>
            15 juillet 2022: récolte d'environ 9 kg à partir de l'essaim 2022
            <br/>
            18 juin 2022: récolte d'environ 19 kg de miel à partir de la ruche ocre lcalisée à Montpellier
            <br/>
            4 juin 2022: transfert de l'essaim 2022 et de la ruche jaune à La Llagonne
            <br/>
            24 mai 2022: achat de 2 ruches à M. Bonneau qui ont été nommés 'ruche du milieu' et 'essaim 2022'.
            <br/>
            10 et 19 avril 2022: récupération de 2 essaims de 3,3 et 0,9 kg d'abeilles à partir des ruches verte et à poignées ont donné la ruche jaune et la ruchette "ocre" élevées à Montpellier. D'autres essaimages ont eu lieu à partir de ces ruches mais n'ont pu être récupérés.
            <br/>
            20 novembre 2021, 1 janvier et 27 mars 2022: mort des ruches ocre, du milieu et carré ocre.
            <br/>
            19 septembre 2021: Récolte des hausses presque toutes vides sauf celle de la ruche du milieu et de la ruche carré ocre élevée à La Llagonne. Total d'environ 13 kg de miel dont plus d'un tiers non operculé et traité à part.
            <br/>
            22 août 2021: Perte de la ruche jaune.
            <br/>
            23 juillet 2021: La ruche jaune est "mangée" par de la fausse teigne. Après avoir jeté tous les cadres, transfert des quelques abeilles restantes dans la ruchette ocre avec 4 cadres "neufs" dont un étiré.
            <br/>
            Les ruches en transhumance ont largement essaimé en notre absence... Leçon: ne pas monter des carnica en transhumance.
            <br/>
            12 juin 2021: transhumance des essaims de l'année (ruche à poignée et ruche au carré ocre) de Montpellier à La Llagonne
            <br/>
            29 avril et 12 mai 2021: essaimage de 3 kg d'abeilles à partir de la ruche ocre qui a donné la ruchette "ocre" puis la ruche au carré ocre élevées à Montpellier. D'autres essaimages ont suivi à partir des ruches ocre et verte. Un seul essaim a été récupéré (le 12 mai) et occupe la ruche à poignées, elle ausi élevée à Montpellier.
            <br/>
            14 avril 2021: le lilas est en fleur depuis plusieurs jours à Montpellier, pas encore à Pignan.
            <br/>
            4 avril 2021: retrait de la ruche "carré bleu" qui est vide d'abeilles.
            <br/>
            21 puis 28 mars 2021: ajout de hausses sur la ruche historique puis sur les ruches verte, ocre et "du milieu".
            <br/>
            13 mars 2021: retrait des bandes APIVAR
            <br/>
            12 novembre 2020: la ruche "essaim 2019" est vide d'abeilles mais chargée de miel !!!!!
             – ajout de bandes APIVAR dans toutes les autres ruches
            <br/>
            26 septembre 2020: retrait de toutes les hausses et récolte d'environ 17 kg de miel des derniers cadres des différentes hausses (ruches jaune, verte, carré bleu, historique et essaim 2019)
            <br/>
            22 puis 24 août 2020: retour des deux ruches llagonnaises à Montpellier puis à Pignan
            <br/>
            10 août 2020: récolte d'un peu plus de 14 kg de miel à partir des ruches posées à La Llagonne
            <br/>
            22 juillet 2020: récolte d'environ 13,5 kg de miel à partir des ruches "jaune" et "verte" et rapatriement de la ruche "ocre" de Montpellier à Pignan
            <br/>
            20 juin 2020: transhumance des ruches "essaim 2019" et "carré bleu" à La Llagonne 
            <br/>
            8 juin 2020: récolte d'environ 14,5 kg de miel à partir de la ruche jaune
            <br/>
            15 mai 2020: essaimage de 2,6 kg d'abeilles à partir de la ruche "essaim 2019 qui a donné la ruche "carré bleu" élevée à Montpellier
            <br/>
            15 mai 2020: transfert de la ruche verte à Pignan
            <br/>
            2 mai 2020: essaimage de 0,94 kg d'abeilles à partir de la ruche du milieu et remises dans la ruche du milieu le jour même
            <br/>
            30 avril ou 1 mai 2020: essaimage probable à partir de la ruche "essaim 2019" mais essaim non récupéré
            <br/>
            29 avril 2020: essaimage d'1,7 kg d'abeilles à partir de la ruche du milieu qui a donné la ruche "ocre" élevée à Montpellier
            <br/>
            23 avril 2020: essaimage de 5 à 7 kg d'abeilles à partir de la ruche du milieu qui a donné la ruche "verte" élevée à Montpellier
            <br/>
            8 mars 2020: retrait des bandes antivarroa APIVAR des 4 ruches présentes cet hiver
            <br/>
          </div>
        </balise>
        <balise id="photos">
          <h4 align='left'>Photos</h4>
          <div style={{margin:"0 10%"}}>
          <ImageGallery items={images} />
          </div>
        </balise>
        <balise id="genealogie">
          <h4 align='left'>Généalogie des essaims</h4>
          <div style={{margin:"0 10%"}}>
          <img src={Genealogie} alt="this is car image" />
          </div>
        </balise>
       </div>
    );
  }
}

export default App;